// Render-time helper for news post images. Posts created through the
// new admin editor store fully-qualified Sirv URLs in `images`; the
// 4 legacy seed entries (from `news.json` before the Postgres port)
// store bare filenames served from `webapp/public/images/feed/`.
// Return the correct `src` for either shape so callers don't branch.
export const newsImageUrl = (image: string): string => {
  if (/^https?:\/\//i.test(image)) return image;
  return `/images/feed/${image}`;
};
